import React from 'react';
import styled from "@emotion/styled";
import PropTypes from 'prop-types';
import {ReactComponent as Icon} from "../../assets/DevliceryBox.svg";

const ButtonWrapper = styled.div`
    width: fit-content;
    height: 36px;
    padding: 10px;
    
    display: flex;
    justify-content: center;
    align-items: center;
    
    /* default/gray/100 */
    /* default/gray/400 */
    border: 1px solid #CBD5E0;
    box-sizing: border-box;
    border-radius: 4px;
     
    background: var(--color-gray-100) center;
    transition: background 0.8s;
    user-select: none;
   
    
    :hover {
      background: rgba(118,118,117,0.28) radial-gradient(circle, transparent 1%, rgba(118,118,117,0.17) 1%) center/15000%;
    }
    
    :active {
      background-color: #767675;
      background-size: 100%;
      transition: background 0s;
    }
    
    :focus {
        outline: none
    }

    font-family: Metropolis;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    /* identical to box height, or 100% */
    
    /* default/blue/600 */
    color: var(--color-blue-600);
`;


function IconActionButton(props) {
    return (
        <ButtonWrapper onClick={props.onClick}>
            <Icon style={{marginRight: "11px"}}/>
            {props.children}
        </ButtonWrapper>
    );
}

IconActionButton.propTypes = {
    onClick: PropTypes.func.isRequired
};
IconActionButton.defaultProps = {};

export default IconActionButton;
